import React from "react";
import { Fragment, useState } from "react";
import { Dialog, Menu, Transition, Disclosure } from "@headlessui/react";
import {
  Link,
  Navigate,
  useSearchParams,
  useLocation,
  useParams,
} from "react-router-dom";
import mainLogo from "../mglogo.png";
import {
  BellIcon,
  CalendarIcon,
  ChartBarIcon,
  FolderIcon,
  HomeIcon,
  InboxIcon,
  MenuAlt2Icon,
  ShoppingBagIcon,
  UsersIcon,
  XIcon,
  DocumentIcon,
  ClipboardIcon,
  ShoppingCartIcon,
  TemplateIcon,
} from "@heroicons/react/outline";
import {
  CheckCircleIcon,
  SearchIcon,
  ColorSwatchIcon,
  CogIcon,
} from "@heroicons/react/solid";
import axios from "axios";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

class Employeemodaledit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarOpen: false,
      setSidebarOpen: false,
      showmsg: false,
      logoutRedirect: false,
      name: "",
      password: "",
      email: "",
      phone: null,
      employee_designation_id: "",
      country_region_id: "",
      address_street_one: "",
      address_street_two: "",
      city: "",
      state_id: "",
      zip_code: "",

      success: false,
      redirect: false,
      error_list: [],
      countriesList: [],
      designationsList: [],
      stateList: [],
      loader: "",
      employeeId: this.props.employeeId,
      overLay: "fixed inset-0 bg-black/50 ",
    };
  }
  setLoaderFunction = (e) => {
    this.setState({ loader: "" });
    this.setState({
      overLay: "fixed inset-0 bg-black/30",
    });
  };
  closeLoaderFuncion = (e) => {
    this.setState({ loader: "" });
    this.setState({
      overLay: "",
    });
  };
  close = async (e) => {
    this.setState({ sidebarOpen: false });
  };
  open = async (e) => {
    console.log("open");
    this.setState({ sidebarOpen: true });
  };
  async componentDidMount() {
    this.setLoaderFunction();
    const token = localStorage.getItem("token");
    const { id } = this.props.params;

    const ress = axios
      .get("public/api/employee/edit/" + this.state.employeeId, {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((ress) => {
        this.setState({
          name: ress.data.employee.name,
          password: "",
          email: ress.data.employee.email,
          employee_designation_id:
            ress.data.employee.employee_detail.employee_designation_id,
          remark: "",
          country_region_id:
            ress.data.employee.employee_detail.country_region_id,
          address_street_one:
            ress.data.employee.employee_detail.address_street_one,
          address_street_two:
            ress.data.employee.employee_detail.address_street_two,
          city: ress.data.employee.employee_detail.city,
          state_id: ress.data.employee.employee_detail.state_id,
          zip_code: ress.data.employee.employee_detail.zip_code,
          phone: ress.data.employee.employee_detail.phone,
          stateList: ress.data.employee.employee_detail.states,
          error_list: [],
        });
      });

    const res5 = axios
      .get("public/api/countries", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res5) => {
        this.setState({ countriesList: res5.data.countries });
      });

    const res2 = axios
      .get("public/api/employee/designations", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res) => {
        this.setState({ designationsList: res.data.designations });
      });
    this.closeLoaderFuncion();
  }

  handleInput = (e) => {
    const token = localStorage.getItem("token");
    if (e.target.name === "country_region_id") {
      this.setLoaderFunction();
      const res = axios
        .get("public/api/states/" + e.target.value, {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        })
        .then((res) => {
          this.closeLoaderFuncion();
          this.setState({ stateList: res.data.states });
        });
    } else {
    }

    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  responsesent = (e) => {
    this.props.handleInputemployee(e);
  };

  updateEmployee = async (e) => {
    this.setLoaderFunction();
    e.preventDefault();
    var token = localStorage.getItem("token");
    const headers = {
      authorization: `Bearer ${token}`,
      Accept: "application/json",
    };
    const { id } = this.props.params;

    const res = await axios.post(
      "public/api/employee/update/" + this.state.employeeId,
      this.state,
      { headers }
    );

    if (res.data.success) {
      this.responsesent(res.data.success);
      setTimeout(
        function () {
          //Start the timer
          this.closeLoaderFuncion();
          this.setState({ redirect: true }); //After 1 second, set render to true
        }.bind(this),
        1000
      );
    } else {
      this.closeLoaderFuncion();
      this.setState({ error_list: res.data.data });
      //this.setState({ show: true })
    }
  };

  //Logout function

  logout = async (e) => {
    e.preventDefault();
    var token = localStorage.getItem("token");

    const res = await axios.get("public/api/logout", {
      headers: {
        authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });

    //console.log(res);

    if (res.data.success) {
      localStorage.removeItem("token");

      //Start the timer
      this.setState({ logoutRedirect: true }); //After 1 second, set render to true
    }
  };

  //Logout function

  render() {
    let token = localStorage.getItem("token");

    if (token == null) {
      return <Navigate to={"/Login"} />;
    }

    if (this.state.logoutRedirect) {
      return <Navigate to={"/Login"} />;
    }

    if (this.state.redirect) {
      return <Navigate to={"/Employeelist"} />;
    }

    return (
      <>
        {/*
            This example requires updating your template:
    
            ```
            <html class="h-full bg-gray-100">
            <body class="h-full">
            ```
          */}
        <div>
          <div className={this.state.overLay} aria-hidden="true" />

          <div className="flex flex-col flex-1">
            <main className="flex-1">
              <div className="py-6">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                  <h1 className="text-2xl font-semibold text-gray-900">
                    Update Employee Details
                  </h1>
                </div>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                  {/* Replace with your content */}

                  <div className="hidden sm:block" aria-hidden="true">
                    <div className="py-5">
                      <div className="border-t border-gray-200" />
                    </div>
                  </div>
                  <div className="mt-10 sm:mt-0">
                    <div className={`md:grid md:gap-6 ${this.state.loader}`}>
                      <div className="mt-5 md:mt-0 md:col-span-2">
                        <form onSubmit={this.updateEmployee}>
                          <div className="shadow overflow-hidden sm:rounded-md">
                            <div className="px-4 py-5 bg-white sm:p-6">
                              <div className="grid grid-cols-6 gap-6">
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="name"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                      Name
                                    </span>
                                  </label>
                                  <input
                                    type="text"
                                    name="name"
                                    id="name"
                                    value={this.state.name}
                                    autoComplete="given-name"
                                    onChange={this.handleInput}
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />

                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.name}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="email"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                      Email(User Name)
                                    </span>
                                  </label>
                                  <input
                                    type="text"
                                    name="email"
                                    id="email"
                                    value={this.state.email}
                                    onChange={this.handleInput}
                                    autoComplete="email"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.email}
                                  </p>
                                </div>

                                <div className="col-span-6 sm:col-span-3">
                                  <label
                                    htmlFor="employee_designation_id"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Designation
                                  </label>
                                  <select
                                    id="employee_designation_id"
                                    name="employee_designation_id"
                                    onChange={this.handleInput}
                                    value={this.state.employee_designation_id}
                                    autoComplete="employee_designation_id"
                                    className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  >
                                    <option value="">------</option>
                                    {this.state.designationsList.map(
                                      (number) => (
                                        <option value={number.id}>
                                          {number.name}
                                        </option>
                                      )
                                    )}

                                    <p
                                      className="mt-2 text-sm text-red-600"
                                      id="email-error"
                                    >
                                      {
                                        this.state.error_list
                                          .employee_designation_id
                                      }
                                    </p>
                                  </select>
                                </div>

                                <div className="col-span-6 sm:col-span-6 lg:col-span-3">
                                  <label
                                    htmlFor="phone"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Employee Phone
                                  </label>
                                  <input
                                    type="number"
                                    name="phone"
                                    id="phone"
                                    onChange={this.handleInput}
                                    value={this.state.phone}
                                    autoComplete="phone"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.phone}
                                  </p>
                                </div>

                                <div className="col-span-6 sm:col-span-6 lg:col-span-6 ">
                                  <div>
                                    <h3 className="text-lg leading-6 font-medium text-gray-900">
                                      Address Details
                                    </h3>
                                  </div>
                                </div>

                                <div className="col-span-6 sm:col-span-2">
                                  <label
                                    htmlFor="country_region_id"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Country / Region
                                  </label>
                                  <select
                                    id="country_region_id"
                                    name="country_region_id"
                                    onChange={this.handleInput}
                                    value={this.state.country_region_id}
                                    autoComplete="country_region_id"
                                    className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  >
                                    <option value="">------</option>
                                    {this.state.countriesList.map((number) => (
                                      <option value={number.id}>
                                        {number.name}
                                      </option>
                                    ))}

                                    <p
                                      className="mt-2 text-sm text-red-600"
                                      id="email-error"
                                    >
                                      {this.state.error_list.country_region_id}
                                    </p>
                                  </select>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="address_street_one"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Street AddressLine one
                                  </label>
                                  <input
                                    type="text"
                                    name="address_street_one"
                                    id="address_street_one"
                                    value={this.state.address_street_one}
                                    onChange={this.handleInput}
                                    autoComplete="address-level2"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.address_street_one}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="city"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    AddressLine two
                                  </label>
                                  <input
                                    type="text"
                                    name="address_street_two"
                                    id="address_street_two"
                                    value={this.state.address_street_two}
                                    onChange={this.handleInput}
                                    autoComplete="address_street_two"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.address_street_two}
                                  </p>
                                </div>

                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="city"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    City
                                  </label>
                                  <input
                                    type="text"
                                    name="city"
                                    onChange={this.handleInput}
                                    value={this.state.city}
                                    id="city"
                                    autoComplete="address-level2"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.city}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                                  <label
                                    htmlFor="region"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    State / Province
                                  </label>

                                  <select
                                    id="state"
                                    name="state_id"
                                    onChange={this.handleInput}
                                    value={this.state.state_id}
                                    autoComplete="state_id"
                                    className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  >
                                    <option value="">------</option>
                                    {this.state.stateList.map((number) => (
                                      <option value={number.id}>
                                        {number.name}
                                      </option>
                                    ))}

                                    <p
                                      className="mt-2 text-sm text-red-600"
                                      id="email-error"
                                    >
                                      {this.state.error_list.state_id}
                                    </p>
                                  </select>
                                </div>

                                <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                                  <label
                                    htmlFor="zip_code"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    ZIP / Postal code
                                  </label>
                                  <input
                                    type="number"
                                    name="zip_code"
                                    value={this.state.zip_code}
                                    onChange={this.handleInput}
                                    id="zip_code"
                                    autoComplete="zip_code"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.zip_code}
                                  </p>
                                </div>
                              </div>
                            </div>

                            <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
                              <button
                                type="submit"
                                className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                              >
                                Save
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>

                  {/* /End replace */}
                </div>
              </div>
            </main>
          </div>
        </div>

        <div
          aria-live="assertive"
          className="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start"
        >
          <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
            {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
            <Transition
              show={this.state.showmsg}
              //show={true}
              as={Fragment}
              enter="transform ease-out duration-300 transition"
              enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
              enterTo="translate-y-0 opacity-100 sm:translate-x-0"
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 mt-10">
                <div className="p-4">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <CheckCircleIcon
                        className="h-6 w-6 text-green-400"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="ml-3 w-0 flex-1 pt-0.5">
                      <p className="text-sm font-medium text-gray-900">
                        Successfully Saved
                      </p>
                      <p className="mt-1 text-sm text-gray-500"></p>
                    </div>
                    <div className="ml-4 flex-shrink-0 flex">
                      <button
                        className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        onClick={() => {
                          this.setState({ showmsg: false });
                        }}
                      >
                        <span className="sr-only">Close</span>
                        <XIcon className="h-5 w-5" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Transition>
          </div>
        </div>
      </>
    );
  }
}

export default (props) => <Employeemodaledit {...props} params={useParams()} />;
